import useSWR from 'swr';

const useSettings = (key?: string) => {
  const { data } = useSWR('/settings');
  return key ? data?.[key] : data;
};

export default useSettings;
